import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/utils/ui-utils';

type Props = {
  variant?: 'text' | 'badge';
};

const CellSkeleton = ({ variant = 'text' }: Props) => (
  <div className={cn('flex items-center', variant === 'badge' ? 'h-6' : 'h-5')}>
    <Skeleton className='h-2 w-8' />
  </div>
);

export default CellSkeleton;
